// Shared occasion options for the create + edit forms. Keep the values in sync
// with the backend OCCASION_CAPABILITIES map (server.py) — they drive which
// guest features (rsvp / seating) an event exposes.
export const OCCASIONS = [
  { value: '', label: 'Not specified' },
  { value: 'vacation', label: 'Vacation / Trip' },
  { value: 'wedding', label: 'Wedding' },
  { value: 'birthday', label: 'Birthday' },
  { value: 'corporate', label: 'Corporate' },
  { value: 'other', label: 'Other' },
];
